var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEnIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("mask", {
  id: "enIcon_svg__a",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z",
  fill: "#fff"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#enIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.174 4.458A12.342 12.342 0 0 0 .04 8.768h6.444l-4.31-4.31ZM23.96 8.769a12.344 12.344 0 0 0-2.134-4.31l-4.31 4.31h6.444ZM.04 15.231a12.343 12.343 0 0 0 2.134 4.31l4.31-4.31H.04ZM19.542 2.174A12.343 12.343 0 0 0 15.232.04v6.444l4.31-4.31ZM4.458 21.826a12.344 12.344 0 0 0 4.31 2.134v-6.444l-4.31 4.31ZM8.769.04a12.343 12.343 0 0 0-4.31 2.134l4.31 4.31V.04ZM15.231 23.96a12.343 12.343 0 0 0 4.31-2.134l-4.31-4.31v6.444ZM17.516 15.231l4.31 4.31a12.344 12.344 0 0 0 2.134-4.31h-6.444Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.898 10.435H13.565V.102a12.12 12.12 0 0 0-3.13 0v10.333H.102a12.12 12.12 0 0 0 0 3.13h10.333v10.333a12.12 12.12 0 0 0 3.13 0V13.565h10.333a12.12 12.12 0 0 0 0-3.13Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "m15.13 15.13 5.355 5.355c.247-.246.482-.503.706-.77l-4.585-4.585H15.13ZM8.87 15.13l-5.355 5.355c.246.247.503.482.77.706l4.585-4.585V15.13ZM8.87 8.87 3.515 3.515a12.03 12.03 0 0 0-.706.77L7.394 8.87H8.87ZM15.13 8.87l5.355-5.355a12.02 12.02 0 0 0-.77-.706L15.13 7.394V8.87Z",
  fill: "#D80027"
}))));
export { SvgEnIcon as ReactComponent };
export default __webpack_public_path__ + "69103c06aa3bd95a22be393dd8c1746d.svg";